import { createReducer } from '@reduxjs/toolkit';
import settings from 'Cloud/settings';
import { type IntegrationState } from 'reactApp/modules/integration/integration.types';

export const initialState: IntegrationState = {
    parentOrigin: settings.request?.query_params?.['parent_origin'],
    client: settings.request?.query_params?.['integration_client'],
    userId: settings.request?.query_params?.['integration_uid'],
};

export const integrationReducer = createReducer(initialState, {});
